import { Box, Center, Spinner } from "@chakra-ui/react"
import { useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { AuthContext } from "../App"






const IndexPage = () => {

    const navigate = useNavigate()

    const { user } = useContext(AuthContext)



    useEffect(() => {
        if (user?.is_staff ) navigate('/admin')
        else navigate('/user')
    },[])

    
    return <Center h='90vh'>
        <Box>
            <Box 
                bgImage='/logo_black.svg' 
                w='80px' h='33px' 
                bgPos='center' bgSize='contain'
                bgRepeat='no-repeat'
                mb='12px'
            />
            <Center mr='8px'>
                <Spinner size='sm' color='#171C22' />
            </Center>
        </Box>
    </Center>
}


export default IndexPage